"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mixHeadersOptions = exports.pick = void 0;
function pick(params, keys) {
    if (Array.isArray(params) || params === undefined || params === null) {
        return params;
    }
    if (params instanceof FormData) {
        var result_1 = new FormData();
        params.forEach(function (value, key) {
            if (keys.includes(key)) {
                result_1.append(key, value);
            }
        });
        return result_1;
    }
    else {
        var result_2 = __assign({}, params);
        Object.keys(result_2).forEach(function (key) {
            if (!keys.includes(key)) {
                delete result_2[key];
            }
        });
        return result_2;
    }
}
exports.pick = pick;
function mixHeadersOptions(options, predefinedHeaders) {
    var _a = options || {}, headers = _a.headers, rest = __rest(_a, ["headers"]);
    return __assign(__assign({}, rest), { headers: __assign(__assign({}, headers), predefinedHeaders) });
}
exports.mixHeadersOptions = mixHeadersOptions;
